'use client';
import Link from 'next/link';
import Navbar from '@/components/ui/Navbar';
import Footer from '@/components/ui/Footer';

export default function CartPage() {
  return (
    <div className="min-h-screen bg-[#030812] text-white">
      <Navbar />
      <main>
        <section className="border-b border-white/10 bg-[linear-gradient(135deg,#07111f_0%,#0f1f3d_100%)] py-16">
          <div className="container mx-auto max-w-6xl px-4">
            <nav className="mb-6 flex items-center gap-2 text-sm text-slate-400">
              <Link href="/" className="hover:text-white transition">Home</Link>
              <span>/</span>
              <span className="text-white">Cart</span>
            </nav>
            <h1 className="text-3xl font-black text-white md:text-4xl">Your Cart</h1>
          </div>
        </section>

        <section className="py-20">
          <div className="container mx-auto max-w-3xl px-4 text-center">
            <div className="rounded-2xl border border-white/10 bg-white/[0.04] p-12">
              <span className="text-6xl">🛒</span>
              <h2 className="mt-6 text-xl font-black text-white">Your cart is empty</h2>
              <p className="mt-3 text-sm text-slate-300">Browse our range of refurbished printers and add items to your cart.</p>
              <div className="mt-8 flex flex-wrap justify-center gap-4">
                <Link href="/home-printers" className="rounded-lg bg-violet-600 px-6 py-3 text-sm font-bold text-white transition hover:bg-violet-500">
                  Home Printers
                </Link>
                <Link href="/office-printers" className="rounded-lg border border-white/20 bg-white/10 px-6 py-3 text-sm font-bold text-white transition hover:bg-white/20">
                  Office Printers
                </Link>
                <Link href="/inkjet-printers" className="rounded-lg border border-white/20 bg-white/10 px-6 py-3 text-sm font-bold text-white transition hover:bg-white/20">
                  Inkjet Printers
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
